export default __webpack_public_path__ + "static/media/item-3-safari-14.286b0cb9.png";